<ng-container screenAnalytics="mission-lotam-view">
    <div class="modal-header no-icon">
        <h3 class="modal-title">Mission LOTAM</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <button
            type="button"
            aria-label="Close"
            class="close"
            (click)="onCancel()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body inner-container-and-footer max-height">
        <lotam-details
            class="modal-body-content"
            [lotam]="lotam"
            [organisation]="organisation"
            [missionLocation]="missionLocation"
            [missionStatus]="status"
            [isAcknowledged]="isAcknowledgedInMission"
        >
            <div class="row top-buffer">
                <div class="col-xs-12 display-label">Crew Acknowledgements</div>
                <div class="col-xs-12">
                    <static-table
                        *ngIf="
                            acknowledgementRows.length > 0;
                            else noAcknowledgements
                        "
                        [availableColumns]="acknowledgementColumns"
                        [tableData]="acknowledgementRows"
                        [tableConfig]="acknowledgementTableConfig"
                    >
                    </static-table>
                    <ng-template #noAcknowledgements>
                        <div class="data">
                            No one has acknowledged this LOTAM for the mission
                        </div>
                    </ng-template>
                </div>
            </div>
        </lotam-details>
    </div>

    <div class="modal-footer">
        <p
            *ngIf="!this.isReadOnly && !isAcknowledgedInMission"
            class="text-danger"
            style="display: inline-block"
        >
            You have not acknowledged this LOTAM
        </p>
        <button
            *ngIf="!this.isReadOnly"
            type="button"
            class="btn btn-primary relative"
            [disabled]="isAcknowledgedInMission || working"
            (click)="onAcknowledgeForMission()"
        >
            {{ isAcknowledgedInMission ? 'Acknowledged' : 'Acknowledge' }}
            <span
                class="overlay"
                [tooltip]="
                    isAcknowledgedInMission
                        ? 'You have already acknowledged this LOTAM'
                        : 'Acknowledge this LOTAM'
                "
                placement="top"
            ></span>
        </button>
    </div>
</ng-container>
